import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { Response } from 'api/apiBase/Response';

import { getAccountBalances } from '../api';
import { CEX_ACCOUNT_QUERY_KEYS } from '../api.const';
import { GetAccountBalancesRequest, GetAccountBalancesResponse } from '../api.types';

type QueryOptions<T> = Omit<
  UseQueryOptions<Response<GetAccountBalancesResponse>, Error, T>,
  'queryKey' | 'queryFn'
>;

export function useGetAccountBalances<T = Response<GetAccountBalancesResponse>>(
  req: GetAccountBalancesRequest,
  options?: QueryOptions<T>,
) {
  return useQuery({
    queryKey: CEX_ACCOUNT_QUERY_KEYS.list(req),
    queryFn: () => getAccountBalances(req),
    enabled: req.account_ids.length > 0,
    ...options,
  });
}
